import { render, staticRenderFns } from "./InfoLoader.vue?vue&type=template&id=11153375"
import script from "./InfoLoader.vue?vue&type=script&lang=ts"
export * from "./InfoLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports